export default {
  subheadline: 'Ta strona umożliwia dostosowanie zdefiniowanych przez użytkownika znaczeń do własnych celów. Zmiany zostaną zastosowane dla wszystkich użytkowników',
};
